/**
 * Classe condivisa del pulsante "pillola" quadrato (cambio lingua, dark mode,
 * social in footer) — stesso ingombro/raggio/hover ovunque compaia, per
 * stare affiancati senza stonare. Prima duplicata identica tra
 * LanguageSwitcher e ThemeToggle; estratta qui alla terza occorrenza (footer
 * social) invece di copiarla una quarta volta.
 */
export const PILL_BUTTON_CLASS = 'inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-[12px] border border-theme-border text-theme-text-muted transition-colors hover:border-theme-text-subtle hover:bg-theme-bg-subtle hover:text-theme-text';
